import { Body1, Image, Link, Responsive, TooltipDesktop, UIHeading4 } from '@cian/ui-kit';
import * as React from 'react';

import { IParticipation } from '../../types/agents';
import { stopPropagation } from '../../utils/stopPropagation';

import * as styles from './Participation.css';

export interface IParticipationProps {
  participation: IParticipation;
}

export const Participation: React.FC<IParticipationProps> = ({ participation }) => {
  const { title, description, iconUrl, infoUrl, infoTitle } = participation;

  const tooltip = (
    <div className={styles['tooltip']} onClick={stopPropagation}>
      <UIHeading4>{title}</UIHeading4>
      <Body1>{description}</Body1>
      <Link href={infoUrl} target="_blank" rel="noreferrer" fontSize="M">
        {infoTitle}
      </Link>
    </div>
  );

  const icon = (
    <div className={styles['trigger']} data-name="Participation" onClick={stopPropagation}>
      <Image src={iconUrl} width={16} height={16} objectFit="contain" borderRadius={0} preloader={false} />
    </div>
  );

  return (
    <>
      <Responsive desktop>
        <TooltipDesktop title={tooltip} theme="white" placement="bottom-start">
          {icon}
        </TooltipDesktop>
      </Responsive>
      <Responsive phone tablet>
        {icon}
      </Responsive>
    </>
  );
};
